import styled from 'styled-components/macro';

import { large } from 'styles/breakpoints';

export const Bottom = styled.div`
  display: none;

  ${large`
    display: block;
  `}
`;
